// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"221":"605e8b99","752":"605e8b99","818":"2cf7b967"}[chunkId] + ".chunk.css";
};